import { ProductPageService } from '@empathybroker/ebx-gluon';
import { injectable } from 'inversify';

@injectable()
export class TuandcoProductPageService implements ProductPageService {
  getResultId(): string {
    const idSpan = document.querySelector('.product_reference');
    return idSpan && idSpan.textContent;
  }
}
